import { resolveIssuer } from './documentIssuer';

/**
 * Удостоверение клиента заполнено целиком — те же поля, что обязательны в форме проверки
 * (тип, номер, кем выдан, даты выдачи и окончания). Тогда форму показывать незачем.
 */
export const isDocumentComplete = (client) => {
  const doc = client?.document;
  if (!doc) return false;
  return Boolean(
    doc.document_type_id &&
      String(doc.document_number || '').trim() &&
      resolveIssuer(doc.document_issuer) &&
      doc.document_date &&
      doc.document_date_end
  );
};
